import { UcoastEl } from '@/scripts/core/UcoastEl'
import EmblaCarousel, {
	type EmblaCarouselType,
	type EmblaOptionsType,
} from 'embla-carousel'
import { qsRequired } from '@/scripts/core/global'
import AutoHeight from 'embla-carousel-auto-height'

export class ProductTabs extends UcoastEl {
	static htmlSelector = 'product-tabs'

	constructor() {
		super()
		const OPTIONS: EmblaOptionsType = {}
		const OPTIONS_THUMBS: EmblaOptionsType = {
			containScroll: 'keepSnaps',
			dragFree: true,
		}

		const viewportNodeMainCarousel = <HTMLElement>(
			qsRequired('.embla__viewport', this)
		)
		const viewportNodeThumbCarousel = <HTMLElement>(
			qsRequired('.embla-thumbs__viewport', this)
		)
		const emblaApiMain = EmblaCarousel(viewportNodeMainCarousel, OPTIONS, [
			AutoHeight(),
		])
		const emblaApiThumb = EmblaCarousel(
			viewportNodeThumbCarousel,
			OPTIONS_THUMBS
		)

		const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(
			emblaApiMain,
			emblaApiThumb
		)
		const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(
			emblaApiMain,
			emblaApiThumb
		)

		emblaApiMain
			.on('destroy', removeThumbBtnsClickHandlers)
			.on('destroy', removeToggleThumbBtnsActive)

		emblaApiThumb
			.on('destroy', removeThumbBtnsClickHandlers)
			.on('destroy', removeToggleThumbBtnsActive)
	}
}

const addThumbBtnsClickHandlers = (
	emblaApiMain: EmblaCarouselType,
	emblaApiThumb: EmblaCarouselType
): (() => void) => {
	const slidesThumbs = emblaApiThumb.slideNodes()

	const scrollToIndex = slidesThumbs.map(
		(_, index) => (): void => emblaApiMain.scrollTo(index, true)
	)

	slidesThumbs.forEach((slideNode, index) => {
		slideNode.addEventListener('click', scrollToIndex[index], false)
	})

	return (): void => {
		slidesThumbs.forEach((slideNode, index) => {
			slideNode.removeEventListener('click', scrollToIndex[index], false)
		})
	}
}

const addToggleThumbBtnsActive = (
	emblaApiMain: EmblaCarouselType,
	emblaApiThumb: EmblaCarouselType
): (() => void) => {
	const slidesThumbs = emblaApiThumb.slideNodes()

	const toggleThumbBtnsState = (): void => {
		emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap())
		const previous = emblaApiMain.previousScrollSnap()
		const selected = emblaApiMain.selectedScrollSnap()
		slidesThumbs[previous].classList.remove('embla-thumbs__slide--selected')
		slidesThumbs[selected].classList.add('embla-thumbs__slide--selected')
	}

	emblaApiMain.on('select', toggleThumbBtnsState)
	emblaApiThumb.on('init', toggleThumbBtnsState)

	return (): void => {
		const selected = emblaApiMain.selectedScrollSnap()
		slidesThumbs[selected].classList.remove('embla-thumbs__slide--selected')
	}
}
